/*
 * Lemonade Training Oy copy rights all right reserved.
 * Public landing page contract: the LandingPage document and the
 * getLandingPageBasedOnName callable.
 */

/**
 * The stored LandingPage document, served to anonymous visitors.
 * `active` is absent until the owner first touches the visibility switch:
 * absent or `true` means public, only `false` hides the page.
 */
export interface LandingPageDoc {
  name: string;
  ownerUID: string;
  /** Absent on an independent coach's page. */
  boxID?: string;
  active?: boolean;
  bannerPicURL?: string;
  brandColor?: string | null;
  metaTitle?: string | null;
  metaDescription?: string | null;
  tagline?: string;
}

/**
 * getLandingPageBasedOnName: `null` for an unknown name. A hidden page is
 * refused with failed-precondition and `details.reason` HIDDEN.
 */
export type GetLandingPageByNameRequest = { pageName: string };
export type GetLandingPageByNameResponse = LandingPageDoc | null;

/** `details.reason` on a failed-precondition refusal. Add members; never rename. */
export const LANDING_PAGE_REFUSAL_REASON = {
  HIDDEN: "landing_page_hidden",
} as const;
export type LandingPageRefusalReason =
  (typeof LANDING_PAGE_REFUSAL_REASON)[keyof typeof LANDING_PAGE_REFUSAL_REASON];

/** The one reading of `active`: absent means public, only `false` hides. */
export const isLandingPagePublic = (
  page: Pick<LandingPageDoc, "active">,
): boolean => page.active !== false;
